import { AppCountry, RenderableConfig } from '../app.models';
import { InjectionToken } from '@angular/core';

export enum FormControlTypes {
  INPUT,
  SELECT,
  DATE,
  HIDDEN,
}

export interface FormSelectOption {
  label: string;
  value: string;
  childControlName?: string;
  childLabel?: string;
  options?: FormSelectOption[];
  filteredOptions?: any;
}

export interface FormValidatorConfig {
  type: FormValidators;
  arg?: any;
  message?: string;
}

export interface FormComboSubOptions extends FormSelectOption {
  subSelectLabel: string;
  subSelectControlName: string;
  subOptions?: FormSelectOption[];
  subDisabled?: boolean;
  subValidators?: FormValidatorConfig[];
  subValue: string;
}

export const FORMS_TOKEN = new InjectionToken<FormsConfig>('for forms data');

export type FormInputTypes = 'text' | 'number';
export type FormValidators = 'required' | 'max' | 'min' | 'pattern';

export interface FormsConfig extends RenderableConfig {
  controls: FormsControlConfig[];
}

export interface FormsControlConfig {
  name: string;
  controlType: FormControlTypes;
  inputType?: FormInputTypes;
  label?: string;
  placeholder?: string;
  hint?: string;
  options?: FormSelectOption[];
  filteredOptions?: any;
  comboOptions?: FormComboSubOptions[];
  children?: FormsControlConfig[];
  dependent?: boolean;
  validators?: FormValidatorConfig[];
  disabled?: boolean;
  format?: string;
  value?: string;
}

export interface FormErrorConfig {
  [controlName: string]: {
    name: string;
    message?: string;
  }[];
}

export type ControlStatus = 'VALID' | 'INVALID' | 'PENDING' | 'DISABLED';

export class FormCountryComboOption implements FormComboSubOptions {
  public get label() {
    return this._config.name;
  }

  public get value() {
    return this._config.code;
  }

  public get subValue() {
    return this._subValue!;
  }

  private _subOptions: FormSelectOption[];
  public get subOptions() {
    return this._subOptions;
  }

  public get subDisabled() {
    return this._subDisabled;
  }

  public readonly subSelectLabel = 'State';
  public readonly subSelectControlName = 'state';
  public readonly subValidators: FormValidatorConfig[] = [
    {
      type: 'required',
      message: `${this.subSelectLabel} is required`,
    },
  ];

  constructor(
    private _config: AppCountry,
    private _subValue?: string,
    private _subDisabled = false
  ) {
    this._subOptions =
      (this._config.states &&
        this._config.states.map((state) => ({
          label: state.name,
          value: state.code,
        }))) ||
      [];
  }
}
export type parentSelectionError =
  | { invalidOption: boolean }
  | { countryNotFoundError: boolean };
